import { gql } from '@efficiently/client-core-graphql-models';

export const DELETE_PROJECT_DESIGN_CHANGE_DOCUMENT = gql(`
	mutation DeleteProjectDesignChangeDocument($_id: ID!, $contentId: ID!) {
		deleteProjectDesignChangeDocument(_id: $_id, contentId: $contentId)
	}
`);
